import PropTypes from 'prop-types';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { formatSelect, lengthValidation500, required } from '../Forms/utils';

import { COURIER_ERROR_TYPES } from './constants';

import { secondaryColor } from '../../theme';
import { CHECKBOX_GROUP, STYLED_TEXT } from '../Forms/fieldTypes';

const CourierErrorFormComponent = (props) => {
  const { form, onCourierErrorSubmit, initialValues } = props;
  const formData = [
    {
      keyName: 'errorTypes',
      fieldType: CHECKBOX_GROUP,
      options: formatSelect(COURIER_ERROR_TYPES, 'label', 'label'), // the option's value and the label should be the same
      validate: [required],
    },
    {
      keyName: 'details',
      label: 'Details',
      fieldType: STYLED_TEXT,
      multiline: true,
      rows: 4,
      validate: [required, lengthValidation500],
    },
  ];
  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onCourierErrorSubmit}
      submitText="Notify Building Staff"
      isFullWidthSubmit
      initialValues={initialValues}
      title="Courier Error"
      customSubmitStyle={{ backgroundColor: secondaryColor }}
      disabled={false}
      backButton={false}
      isFullWidthForm
      enableReinitialize
    />
  );
};

CourierErrorFormComponent.defaultProps = {
  initialValues: null,
};

CourierErrorFormComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onCourierErrorSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object),
};

export default CourierErrorFormComponent;
